import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const copperRidgeMetadata = {
  id: 'copper-ridge',
  name: 'Copper Ridge',
  description:
    'A high-desert mountain championship through copper cliffs, sparse pine and wind-polished scrub.',
  environmentPreset: 'goldenHour',
  metadata: {
    location: 'Red Mesa, Colorado',
    regionType: 'high-desert mountain',
    difficulty: 76,
    typicalWind: [10, 22] as const,
    greenSpeed: [10.5, 11] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Elevation, crosswinds, uneven lies and strategic rock',
    signatureHoles: [4, 9, 15, 18],
    tournamentEventId: 'event-2',
    previewTheme: 'copper-cliffs',
    environmentPalette: {
      fairway: '#748044',
      rough: '#9b7040',
      bunker: '#c58a52',
      water: '#477b87',
      haze: '#d79b72',
    },
    vegetationStyle: 'sparse ponderosa pine and desert scrub',
    terrainStyle: terrainPreset('copper-escarpment', 18, 180, 1.25).id,
  },
};
const pars = [4, 5, 3, 3, 4, 4, 5, 4, 5, 4, 3, 4, 4, 5, 4, 3, 4, 4];
const yards = [
  430, 565, 205, 178, 455, 410, 590, 390, 535, 445, 190, 420, 470, 575, 440, 165, 425, 462,
];
const names = [
  'Mesa Gate',
  'Juniper Rise',
  'Copper Chute',
  'Canyon Flight',
  'Red Shelf',
  'Crosswind',
  'High Basin',
  'Scrub Line',
  'Gravity Run',
  'Saddle',
  'Echo Rock',
  'Dry Wash',
  'Long Shadow',
  'Summit Road',
  'Sky Green',
  'Copper Bowl',
  'Ridge Walk',
  'Rock Cathedral',
];
const opts: Partial<HolePlan>[] = [];
opts[3] = { water: 'carry', elevation: { tee: 18, landing: 2, green: -16 }, trees: 1, rocks: 4 };
opts[8] = { elevation: { tee: 16, landing: -8, green: -14 }, rocks: 3 };
opts[14] = { elevation: { tee: 0, landing: 8, green: 16 }, rocks: 4 };
opts[17] = { rocks: 8, bunkerCount: 2 };
export const createCopperRidgeDocument = () =>
  authorCourse({ ...copperRidgeMetadata, plans: plans(names, pars, yards, opts) });
